import { useEffect, useImperativeHandle } from 'react'
import { useForm, Controller } from 'react-hook-form'
// import Ditto from '../ditto/register.editor'

// 封装 useForm
export default (fieldsConfig, ref) => {
  const {
    control,
    getValues,
    watch,
    setValue,
    reset,
    register,
    handleSubmit,
    trigger,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: fieldsConfig,
  })

  if (ref) {
    useImperativeHandle(ref, () => ({
      getValues,
      handleSubmit,
      trigger,
    }))
  }

  useEffect(() => {
    reset(fieldsConfig)
  }, [fieldsConfig])

  return {
    control,
    watch,
    getValues,
    setValue,
    reset,
    register,
    handleSubmit,
    Controller,
    errors,
    isDirty,
  }
}
